export default __webpack_public_path__ + "static/media/currency-exchange.d308f3d6.svg";